import React, {useEffect, useState} from "react";
import Api from "../../../Api/api";
import {toast} from "react-toastify";
import {BeatLoader} from "react-spinners";
import AdminEditProzessOptionsTable from "./table";
import {AES, enc} from "crypto-js";
import {useStateValue} from "../../../states/StateProvider";
import {useForm} from "react-hook-form";

const AdminEditProzessOptions = () => {

    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(true)
    const [loadingSave, setLoadingSave] = useState(false)

    const [{secretKey}, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))

    const {
        register, getValues, setValue, watch, handleSubmit, formState, reset, formState: {errors, touchedFields},
        control
    } = useForm({mode: "onChange"});
    const {isValid} = formState;


    useEffect(() => {
        getData().then(r => r)
    }, []);

    const getData = async () => {
        setLoading(true)
        await Api().post('/sp_getProcessOptions').then(res => {
                const sortedOptions = res.data.sort((a, b) => {
                    return a.optID - b.optID;
                });
                setTableData(sortedOptions);
            }
        ).catch(e => {
            toast.error('Etwas ist schief gelaufen!!')
        })
        setLoading(false)
    }

    const onSubmit = async (data) => {
        setLoadingSave(true)

        const formData = new FormData();
        formData.append('optID', data.newOptionID);
        formData.append('optValue', data.newOptionValue);

        Api().post('/sp_addProcessOption', formData).then(res => {
            if (res.status === 200) {
                toast.success('Die Option wurde erfolgreich hinzugefügt.')
            }
            getData().then(r => r)
            reset();
            setLoadingSave(false)
        }).catch(e => {
            setLoadingSave(false)
            toast.error('Beim Speichern ist ein Fehler aufgetreten!')
        })
    };


    return (
        <div className='dashboardContainer'>
            <div className='flex justify-start items-center content-center pb-5'>
                <h2 className='text-2xl lg:text-left'>Prozess Optionen</h2>
            </div>
            <div className='bg-white rounded-md mb-5 px-5 pt-4 pb-10 min-h-fit'>
                {
                    loading && <div className='centerItemsRelative h-72'><BeatLoader size='10px'/></div>
                }
                {
                    !loading && tableData.length > 0 &&
                    <table className='min-w-full text-left px-10 border border-offWhite'>
                        <thead className="whitespace-nowrap border-y border-silver border-x-0">
                        <tr className='text-lg'>
                            <th className="text-grey pl-1.5" scope="col">ID</th>
                            <th className="text-grey pl-1.5" scope="col">Prozess Option</th>
                            <th className="text-grey pl-1.5" scope="col"></th>
                        </tr>
                        </thead>
                        {
                            tableData?.map((td, i) => (
                                <AdminEditProzessOptionsTable
                                    key={td.optID}
                                    index={i}
                                    optValue={td.optValue}
                                    optID={td.optID}
                                    getData={getData}
                                />
                            ))
                        }
                    </table>
                }
                <hr/>
                <div className='flex flex-col w-12/12 text-center mt-12'>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <section>
                            <h2 className='font-bold text-lg my-2'>Neue Prozess Option hinzufügen</h2>
                            <div className='flex gap-4 justify-center items-center'>
                                <input type='number'
                                       placeholder='Option ID'
                                       className='w-48'
                                       {...register('newOptionID', {required: true})}
                                       style={{border: errors.newOptionID && '1px solid red'}}
                                />
                                <input type='text'
                                       placeholder='Option Wert'
                                       className='w-96'
                                       {...register('newOptionValue', {required: true})}
                                       style={{border: errors.newOptionValue && '1px solid red'}}
                                />
                            </div>
                        </section>
                        <section>
                            <input
                                className={`${(watch('newOptionID') && watch('newOptionValue')) ? 'bg-mainBlue cursor-pointer' : 'bg-grey cursor-no-drop '} w-52 mt-4 text-white hover:bg-offWhite hover:text-mainBlue text-center px-3 py-2 rounded-md`}
                                type="submit"
                                disabled={!(watch('newOptionID') && watch('newOptionValue'))}
                                value={`${loadingSave ? 'speichere...' : 'Speichern'}`}
                            />
                        </section>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AdminEditProzessOptions
